var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./NumericalWebSearchList.module.scss";
import NumericalWebSearchItem from "../NumericalWebSearchItem/NumericalWebSearchItem";
import { getSettings, getTranslation } from "../../constants/setting";
import { getTextColor } from "../../helper";
import { isLanguageRTL } from "../../../../constants";
var NumericalWebSearchList = function (props) {
    var _b = props.isWithOffset, isWithOffset = _b === void 0 ? false : _b, _j = props.items, items = _j === void 0 ? [] : _j, toggleWebSearchList = props.toggleWebSearchList, language = props.language;
    var _k = useState(1), numberOfShownResult = _k[0], setNumberOfShownResult = _k[1];
    var primary_color = getSettings().primary_color;
    // @ts-ignore
    var _q = useState(items || []), filteredItems = _q[0], setFilteredItems = _q[1];
    var onClickedSeeMore = function () {
        setNumberOfShownResult(function (prevState) { return (prevState === items.length ? 1 : items.length); });
    };
    useEffect(function () {
        setFilteredItems(items.filter(function (item, index) { return index < numberOfShownResult; }));
        toggleWebSearchList(numberOfShownResult);
    }, [numberOfShownResult]);
    return _jsx("div", __assign({ className: "".concat(styles.webSearchList, " ").concat(isWithOffset && styles.webSearchListOffset, " ").concat(isLanguageRTL(language) && styles.rtl) }, { children: _jsxs("div", __assign({ className: styles.webSearchListContent }, { children: [filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.map(function (item, index) {
                    return _jsx(NumericalWebSearchItem, __assign({}, item, { language: language, counter: index + 1 }), 'web_search_item' + index);
                }), (items === null || items === void 0 ? void 0 : items.length) > 1 && _jsx(_Fragment, { children: _jsx("button", __assign({ style: {
                            backgroundColor: getSettings().primary_color,
                            borderColor: getSettings().primary_color,
                            color: getTextColor(primary_color)
                        }, className: styles.btn, onClick: onClickedSeeMore }, { children: numberOfShownResult === items.length ? getTranslation('chatbot.see_less') : getTranslation('chatbot.show_all_results') })) })] })) }));
};
export default NumericalWebSearchList;
